import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api-client';
import type { DashboardStats, HeatmapData, RustyPiece } from '@/lib/types';

export function useDashboardStats(): ReturnType<typeof useQuery<DashboardStats>> {
  return useQuery({
    queryKey: ['insights', 'dashboard'],
    queryFn: () => api.fetch<DashboardStats>('/insights/dashboard'),
  });
}

export function useHeatmap(start: string, end: string): ReturnType<typeof useQuery<HeatmapData>> {
  return useQuery({
    queryKey: ['insights', 'heatmap', start, end],
    queryFn: () => api.fetch<HeatmapData>(`/insights/heatmap?start=${start}&end=${end}`),
  });
}

export function useRustyPieces(): ReturnType<typeof useQuery<RustyPiece[]>> {
  return useQuery({
    queryKey: ['insights', 'rusty'],
    queryFn: () => api.fetch<RustyPiece[]>('/insights/rusty'),
  });
}
